import React, { useEffect, useState, useCallback } from 'react';
import AreaTable from './AreasTable';
import AreaTableTopBar from './AreaTableTopBar';
import { fetchAllAreas } from '../AreasAPI';

const AreaContainer = () => {
    const [areas, setAreas] = useState([]);
    const [error, setError] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [filterOptions, setFilterOptions] = useState({});
    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const refetchAreaData = useCallback(async (options = {}) => {
        setDataLoaded(false);
        try {
            const data = await fetchAllAreas(pageNumber, 10, filterOptions);
            setAreas(data.areas);
            setTotalPages(data.totalPages);
            setError('');
            setDataLoaded(true);
        } catch (error) {
            console.error('Error fetching all areas:', error.message);
            setError('Failed to fetch areas data.');
            setAreas([]);
            setTotalPages(0);
        }
    }, [filterOptions, pageNumber]);

    useEffect(() => {
        refetchAreaData();
    }, [pageNumber, refreshFlag, refetchAreaData, totalPages, fetchTrigger, filterOptions ]);

    return (
        <>
            <AreaTableTopBar
                refetchAreaData={refetchAreaData}
                setPageNumber={setPageNumber}
                setFilterOptions={setFilterOptions}
                setFetchTrigger={setFetchTrigger}
            />
            <AreaTable
                areas={areas}
                setAreas={setAreas}
                setRefreshFlag={setRefreshFlag}
                refetchAreaData={refetchAreaData}
                error={error}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                filterOptions={filterOptions}
                dataLoaded={dataLoaded}
            />
        </>
    );
};

export default AreaContainer;
